export default {
  21: { contest_name: 'Logo Design Contest' },
  19: { contest_name: 'Website Design Contest' },
  63: { contest_name: 'Print Design Contest' },
  20: { contest_name: 'Banner Design Contest' },
  62: { contest_name: 'T-shirt Design Contest' },
  25: { contest_name: 'Business Card Design Contest' },
  26: { contest_name: 'Stationary Design Contest' },
  24: { contest_name: 'Icon Design Contest' },
  28: { contest_name: 'Illustration Design Contest' },
  80: { contest_name: 'Flyer Design Contest' },
  81: { contest_name: 'Brochure Design Contest' },
  82: { contest_name: 'App Design Contest' },
  83: { contest_name: 'Wordpress Design Contest' },
  67: { contest_name: 'Twitter Design Contest' },
  79: { contest_name: 'Graphic Design Contest' },
  30: { contest_name: 'Advertisement Design Contest' },
  29: { contest_name: 'Video Design Contest' },
  23: { contest_name: 'Alter Image Design Contest' },
  27: { contest_name: 'Corporate Identity Design Contest' },
  64: { contest_name: '3D Model Design Contest' },
  65: { contest_name: 'Animation Design Contest' },
  66: { contest_name: 'Facebook Landing Page Design Contest' },
  85: { contest_name: 'Fashion Design Contest' },
  98: { contest_name: 'Tattoo Design Contest' },
};
